import { MainTransportTypes } from '@api/order-reporting/types-deliveries/CountryDeliveriesSummaryReport';



const TableHeader = () => {

	return (
		<>
			<div className='app-grid-header table-header-item'></div>
			<div className='app-grid-header table-header-item'>{MainTransportTypes.sd}</div>
			<div className='app-grid-header table-header-item'>{MainTransportTypes.int}</div>
			<div className='app-grid-header table-header-item'>{MainTransportTypes.dd}</div>
			<div className='app-grid-header table-header-item'>{MainTransportTypes.td}</div>
		</>
	)
}

export default TableHeader;